import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import type { ChartOptions, ChartDataSets } from 'chart.js';

/**
 * @group Data Visualization
 * @component Chart
 * @description A wrapper around <b>mbChart</b>.
 */
@Component({
    selector: 'lsq-chart',
    template: `
        <div
            class="chart-container"
            [style.width]="width || 'auto'"
            [style.height]="height || 'auto'"
        >
            <canvas
                mdbChart
                class="lsq-chart-canvas"
                [style.display]="'block'"
                [style.maxWidth]="'100%'"
                [style.maxHeight]="'100%'"
                [chartType]="'doughnut'"
                [data]="data"
                [labels]="labels"
                [options]="options"
                [colors]="chartColors"
            >
            </canvas>
        </div>
    `,
    styleUrls: ['./lsq-chart.component.scss']
})
export class LsqChartComponent implements OnInit, OnChanges {
    @Input() public data: number[];
    @Input() public labels: string[];
    @Input() public width: string;
    @Input() public height: string;
    @Input() public legend = false;
    @Input() public options: ChartOptions;
    @Input() public colors: string[];
    @Input() public doughnut = true;

    public chartColors: ChartDataSets[];
    public chartData: { name: string; value: number }[];

    public ngOnInit(): void {
        this.chartColors = [
            {
                backgroundColor: this.colors,
                hoverBackgroundColor: this.colors,
                borderWidth: 0
            }
        ];
    }

    public ngOnChanges({ data, labels }: SimpleChanges): void {
        if (!!this.data && (!!data || !!labels)) {
            this.chartData = this.data.map((datum, index) => ({
                name: this.labels[index],
                value: Math.max(datum, 0)
            }));
        }
    }
}
